// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.


import React from 'react';
import './CheckboxGroup.scss';

export default function CheckboxGroup({ options, selectedOptions, onChange }) {
  return (
    <div className="checkbox-group">
      {options.map(option => {
        const isSelected = selectedOptions?.value === option.value;
        return (
          <div
            key={option.value}
            className="checkbox-option"
            onClick={() => {
              if (isSelected) {
                onChange(null);
              } else {
                onChange({ value: option.value, label: option.label });
              }
            }}
          >
            <input
              type="checkbox"
              readOnly
              checked={isSelected}
            />
            <label>{option.label}</label>
          </div>
        );
      })}
    </div>
  );
}
